import { AlertTriangle, Users, ExternalLink } from 'lucide-react';
import type { FrequenciaAluno } from '../../api/hooks/useRelatorios';
import {
  BIMESTRE_LABELS,
  corFrequencia,
  labelStatusFrequencia,
  iniciaisNome,
} from './relatorios-professor-shared';

interface Props {
  aluno: FrequenciaAluno;
  turmaNome?: string;
  mediaTurma?: number;
  onVerFicha: (alunoId: string) => void;
}

export function RelatorioAlunoDetalhePanel({ aluno, turmaNome, mediaTurma, onVerFicha }: Props) {
  const cor = corFrequencia(aluno.percentual);
  const status = labelStatusFrequencia(aluno.percentual, aluno.emRisco);

  return (
    <div className="rel-desk-detail-inner">
      <div className="rel-desk-detail-head">
        <div className="rel-desk-detail-avatar" style={{ background: aluno.emRisco ? '#fef2f2' : '#eff6ff' }}>
          {aluno.emRisco ? (
            <AlertTriangle size={22} style={{ color: '#dc2626' }} />
          ) : (
            <span>{iniciaisNome(aluno.nome)}</span>
          )}
        </div>
        <div className="rel-desk-detail-head-text">
          <h2 className="rel-desk-detail-title">{aluno.nome}</h2>
          <p className="rel-desk-detail-meta">
            {turmaNome || 'Turma'}
            {aluno.matricula ? ` · ${aluno.matricula}` : ''}
          </p>
        </div>
        <span
          className="rel-desk-detail-status"
          style={{
            background: aluno.emRisco ? 'rgba(220,38,38,0.1)' : 'rgba(5,150,105,0.1)',
            color: cor,
          }}
        >
          {status}
        </span>
      </div>

      <div className="rel-desk-detail-kpis">
        <div className="rel-desk-detail-kpi">
          <span className="rel-desk-detail-kpi-val" style={{ color: cor }}>
            {aluno.percentual}%
          </span>
          <span className="rel-desk-detail-kpi-lbl">Frequencia anual</span>
        </div>
        <div className="rel-desk-detail-kpi">
          <span className="rel-desk-detail-kpi-val">
            {aluno.presentes}/{aluno.totalDias}
          </span>
          <span className="rel-desk-detail-kpi-lbl">Dias presentes</span>
        </div>
        <div className="rel-desk-detail-kpi">
          <span className="rel-desk-detail-kpi-val" style={{ color: '#dc2626' }}>
            {aluno.ausentes}
          </span>
          <span className="rel-desk-detail-kpi-lbl">Ausencias</span>
        </div>
        {mediaTurma != null && (
          <div className="rel-desk-detail-kpi">
            <span className="rel-desk-detail-kpi-val" style={{ color: corFrequencia(mediaTurma) }}>
              {mediaTurma}%
            </span>
            <span className="rel-desk-detail-kpi-lbl">Media da turma</span>
          </div>
        )}
      </div>

      <section className="rel-desk-bim-section">
        <h3 className="rel-desk-section-title">Frequencia por bimestre</h3>
        <div className="rel-desk-bim-grid">
          {[1, 2, 3, 4].map((b) => {
            const bim = aluno.porBimestre.find((x) => x.bimestre === b);
            const pct = bim?.percentual;
            const hasData = bim && bim.totalDias > 0;
            return (
              <div key={b} className="rel-desk-bim-card">
                <span className="rel-desk-bim-label">{BIMESTRE_LABELS[b]}</span>
                {hasData && pct != null ? (
                  <>
                    <span className="rel-desk-bim-pct" style={{ color: corFrequencia(pct) }}>
                      {pct}%
                    </span>
                    <span className="rel-desk-bim-sub">
                      {bim.presentes}/{bim.totalDias} dias
                    </span>
                  </>
                ) : (
                  <span className="rel-desk-bim-empty">Sem dados</span>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {aluno.emRisco && (
        <p className="rel-desk-risco-msg">
          Frequencia abaixo de 75% (alerta LDB). Priorize contato com a familia ou encaminhamento
          pedagogico.
        </p>
      )}

      <button type="button" className="rel-desk-btn-ficha" onClick={() => onVerFicha(aluno.alunoId)}>
        <Users size={15} />
        Ver ficha do aluno
        <ExternalLink size={13} />
      </button>
    </div>
  );
}
